/* muse-ui-progress myron.liu version 0.1.0 */
import Vue from 'vue';

var config = {
  zIndex: 2000,
  top: 0,
  speed: 300,
  color: 'primary',
  size: 2,
  className: ''
};

var Progress = Vue.extend({
  name: 'Progress',
  data: function data() {
    return {
      show: false,
      value: 0
    };
  },

  methods: {
    start: function start() {
      if (this.show) return;
      this.show = true;
      this.value = 0;
      this.inc();
    },
    inc: function inc() {
      var _this = this;

      if (this.timer) clearTimeout(this.timer);
      if (this.value >= 100) return;
      var value = this.value;
      var amount = 0;
      switch (true) {
        case value >= 0 && value < 20:
          amount = 10;
          break;
        case value >= 20 && value < 50:
          amount = 4;
          break;
        case value >= 50 && value < 80:
          amount = 2;
          break;
        case value >= 80 && value < 99:
          amount = 0.5;
          break;
        default:
          amount = 0;
      }
      value = value + amount;
      value = Math.max(value, 0);
      value = Math.min(value, 99.4);
      this.value = value;
      this.timer = setTimeout(function () {
        return _this.inc();
      }, config.speed);
    },
    done: function done() {
      var _this2 = this;

      this.value = 100;
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this2.show = false;
      }, 300);
    }
  },
  render: function render(h) {
    return h('mu-fade-transition', [this.show ? h('mu-linear-progress', {
      staticClass: ['mu-progress', config.className].join(' '),
      props: {
        mode: 'determinate',
        size: config.size,
        color: config.color,
        value: this.value
      },
      style: {
        'z-index': config.zIndex,
        'top': config.top + 'px'
      }
    }) : undefined]);
  }
});
var progress = void 0;
var isServer = typeof window === 'undefined';
var mounted = void 0;
var progress$1 = {
  start: function start() {
    if (isServer) return;
    if (!mounted) {
      progress = new Progress({
        el: document.createElement('div')
      });
      document.body.appendChild(progress.$el);
      mounted = true;
    }
    progress.start();
  },
  done: function done() {
    if (isServer || !progress) return;
    progress.done();
  }
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

progress$1.version = '0.1.0';

progress$1.config = function (options) {
  if (!options || Array.isArray(options) || (typeof options === 'undefined' ? 'undefined' : _typeof(options)) !== 'object') return config;
  for (var key in options) {
    if (!options.hasOwnProperty(key)) continue;
    config[key] = options[key];
  }
  return config;
};

progress$1.install = function (Vue$$1, options) {
  progress$1.config(options);
  Vue$$1.prototype.$progress = progress$1;
};

export default progress$1;



//////////////////
// WEBPACK FOOTER
// ./node_modules/muse-ui-progress/dist/muse-ui-progress.esm.js
// module id = j5uk
// module chunks = 0